import React, { useEffect, useRef, useState } from 'react';
import { Share2, Info, ChevronRight, ShoppingCart } from 'lucide-react';
import '../../assets/css/customizerheader.css';
import '../../assets/css/pricebreakdown.css';

// Purely presentational top header for the customizer.
// Does not touch any existing product/placement logic — it only
// renders the step tabs (Design / Preview / Product Info) and the
// top action bar, matching the reference layout.
const CustomizerHeader = ({
  activeStep = 'design',
  setActiveStep = () => { },
  totalPrice = 0,
  priceBreakdown = null,
  onShare = () => { },
  onPreview = () => { },
  onAddToCart = () => { },
}) => {
  const [showBreakdown, setShowBreakdown] = useState(false);
  const priceRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (priceRef.current && !priceRef.current.contains(e.target)) {
        setShowBreakdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const steps = [
    { id: 'design', number: 1, label: 'Design' },
    { id: 'preview', number: 2, label: 'Preview' },
    { id: 'productInfo', number: 3, label: 'Product Info' },
  ];

  return (
    <div className="customizer-header">
      {/* <div className="customizer-header-left">
        <div className="customizer-logo">
          <span className="logo-buy">BUY</span>
          <span className="logo-tshirt">TSHIRT</span>
        </div>
        <div className="customizer-tagline">
          Custom And <strong>BLANKS</strong> Apparel
        </div>
      </div> */}

      <div className="customizer-header-steps">
        {steps.map((step) => {
          const isActive = activeStep === step.id;
          return (
            <button
              key={step.id}
              type="button"
              className={`customizer-step ${isActive ? 'active' : ''}`}
              onClick={() => setActiveStep(step.id)}
            >
              <span className="customizer-step-number">{step.number}</span>
              <span className="customizer-step-label">{step.label}</span>
            </button>
          );
        })}
      </div>

      <div className="customizer-header-right">

        <div className="header-price-wrapper" ref={priceRef}>
          <button
            type="button"
            className="header-price-pill"
            onClick={() => setShowBreakdown((v) => !v)}
          >
            <span>${Number(totalPrice || 0).toFixed(2)}</span>
            <Info size={14} />
          </button>

          {showBreakdown && priceBreakdown && (
            <div className="price-breakdown-popover">
              <div className="price-breakdown-row">
                <span>Product Price x ({priceBreakdown.productQuantity})</span>
                <strong>${priceBreakdown.productPrice.toFixed(2)}</strong>
              </div>

              {priceBreakdown.customizationCount > 0 && (
                <div className="price-breakdown-row">
                  <span>
                    Customization Price x {priceBreakdown.customizationCount} x (
                    {priceBreakdown.productQuantity})
                  </span>
                  <strong>${priceBreakdown.customizationPrice.toFixed(2)}</strong>
                </div>
              )}

              {priceBreakdown.printingMethodCount > 0 && (
                <div className="price-breakdown-row">
                  <span>
                    Printing Method Price x {priceBreakdown.printingMethodCount} x (
                    {priceBreakdown.productQuantity})
                  </span>
                  <strong>${priceBreakdown.printingMethodPrice.toFixed(2)}</strong>
                </div>
              )}

              <div className="price-breakdown-divider" />

              <div className="price-breakdown-row price-breakdown-total">
                <span>Total Price</span>
                <strong>${priceBreakdown.totalPrice.toFixed(2)}</strong>
              </div>
            </div>
          )}
        </div>

        {
          activeStep === 'design' ?
            <button type="button" className="header-preview-button" onClick={() => setActiveStep('preview')}>
              <span>Preview</span>
              <ChevronRight size={16} />
            </button> :
            activeStep === 'preview' ?
              <button type="button" className="header-preview-button" onClick={() => setActiveStep('productInfo')}>
                <span>Continue</span>
                <ChevronRight size={16} />
              </button> :
              <button type="button" className="header-preview-button" >
                <span>Proceed to checkout</span>
                {/* <ShoppingCart size={16} /> */}
              </button>
        }
      </div>
    </div>
  );
};

export default CustomizerHeader;
